module.exports = __webpack_public_path__ + "img/ophthalmology.3cd4228c.svg";